import React from 'react';
import { Document, Image, Page, Text, View } from '@react-pdf/renderer';

import styles from './form-response-pdf-document.styles';

const hasDocIdForPdf = (docId) => typeof docId === 'string' && docId.trim() !== '';

/**
 * @param {{
 *   header: { formTitle: string, user: string, location: string, submittedAt: string, docId?: string },
 *   items: readonly { fieldKey: string, question: string, answer: string, signatureImageSrc: string | null }[],
 * }} props
 */
const FormResponsePdfDocument = ({ header, items }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.title}>{header.formTitle}</Text>
      <View style={styles.metaRow}>
        <Text style={styles.metaLabel}>User</Text>
        <Text style={styles.metaValue}>{header.user}</Text>
      </View>
      {hasDocIdForPdf(header.docId) ? (
        <View style={styles.metaRow}>
          <Text style={styles.metaLabel}>Doc ID</Text>
          <Text style={styles.metaValue}>{header.docId.trim()}</Text>
        </View>
      ) : null}
      <View style={styles.metaRow}>
        <Text style={styles.metaLabel}>Location</Text>
        <Text style={styles.metaValue}>{header.location}</Text>
      </View>
      <View style={styles.metaRow}>
        <Text style={styles.metaLabel}>Submitted</Text>
        <Text style={styles.metaValue}>{header.submittedAt}</Text>
      </View>
      <Text style={styles.sectionTitle}>Responses</Text>
      {items.map((item) => (
        <View key={`qa-${item.fieldKey}`} style={styles.qaBlock}>
          <Text style={styles.question}>{item.question}</Text>
          {item.signatureImageSrc != null && item.signatureImageSrc !== '' ? (
            <Image src={item.signatureImageSrc} style={styles.signatureImage} />
          ) : (
            <Text style={styles.answer}>{item.answer}</Text>
          )}
        </View>
      ))}
    </Page>
  </Document>
);

export default FormResponsePdfDocument;
